import React, { memo } from 'react'
import CarrierStatus from 'components/marketplace/CarrierStatus'
import { makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import ShipmentCarrierScorecardPopover from 'apps/marketplace/pages/shipment-details/components/ShipmentCarrierScorecardPopover/ShipmentCarrierScorecardPopover'
import { formatRelativeTime } from 'transfix-ui'
import { formatRate } from 'utils/formatRate'
import { ICarrierRelatedOptionDetailsFragment } from '../../../graphql/CarrierRelatedOptionDetailsFragment'
import CarrierOptionStatusDot from '../../CarrierOptionStatusDot/CarrierOptionStatusDot'

const useRelatedOptionsRowStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    borderTop: `1px solid ${brandColors.coolGray2}`,
    '&:hover': {
      background: brandColors.coolGray0,
    },
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  carrierValue: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
  },
  createdAtText: {
    color: brandColors.coolGray5,
  },
}))

const RelatedOptionsRow = memo<ICarrierRelatedOptionDetailsFragment>(
  ({ amount, carrierApplication, createdAt, createdBy, status }) => {
    const classes = useRelatedOptionsRowStyles()

    const { id: carrierId, state: carrierState } = carrierApplication || {}
    const { fullName } = createdBy || {}

    return (
      <div className={classes.root}>
        <div className={classes.flexRow}>
          <Typography variant='subtitle1'> {formatRate(amount)}</Typography>
          <CarrierOptionStatusDot showLabel status={status} />
        </div>
        <div className={classes.flexColumn}>
          <div className={classes.carrierValue}>
            <ShipmentCarrierScorecardPopover carrierId={carrierId} />
            <CarrierStatus status={carrierState} />
          </div>
          <Typography variant='body2' className={classes.createdAtText}>
            Created {formatRelativeTime({ datetime: createdAt, isShorthand: true })} ago by{' '}
            {fullName}
          </Typography>
        </div>
      </div>
    )
  }
)

export default RelatedOptionsRow
